import { render, staticRenderFns } from "./exchange-module.vue?vue&type=template&id=f0b243a2&scoped=true&lang=pug&"
import script from "./exchange-module.vue?vue&type=script&lang=js&"
export * from "./exchange-module.vue?vue&type=script&lang=js&"
import style0 from "./exchange-module.vue?vue&type=style&index=0&id=f0b243a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b243a2",
  null
  
)

export default component.exports